// Locale-aware number / date formatting. The active language is set by LanguageProvider.
let active = 'en';
export const setActiveLanguage = (lang) => {
  active = lang;
};
export const getActiveLanguage = () => active;
const LOCALES = { ar: 'ar-AE-u-nu-arab', tl: 'fil-PH', hi: 'hi-IN', ml: 'ml-IN' };
export const localeFor = (lang = active) => LOCALES[lang] || 'en-US';

export const formatNumber = (n, opts = {}) => new Intl.NumberFormat(localeFor(), opts).format(Number(n));
export const formatMoney = (n, currency = 'AED') =>
  active === 'ar'
    ? new Intl.NumberFormat(localeFor(), { style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(n))
    : `${currency} ${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const formatDate = (d, opts = { year: 'numeric', month: 'short', day: 'numeric' }) =>
  d ? new Intl.DateTimeFormat(localeFor(), opts).format(new Date(d)) : '';
